import MyDetails from './MyDetails';

export default MyDetails;
